import { Modal } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import FormComponent, { FormInputTypes } from "../form/form.component";
import { emailValidator, requiredValidator } from "../form/validators.form";
import { toast } from "react-toastify";
import { loadLookups } from "../../helpers/lookup.helper";
import { submitAskForHelp } from "../../store/actions/form.actions";
import { PLButton } from "../common/button";
import "./ask-help.component.scss";
import { useTranslation } from "react-i18next";

const formSettings = [
  {
    name: "email",
    label: "Email *",
    labelKey: "help.email",
    placeholder: "Email",
    placeholderKey: "auth.email",
    type: FormInputTypes.TEXT,
    intype: "email",
    autoComplete: "email",
    validator: emailValidator,
  },
  {
    name: "subject",
    label: "Subject *",
    labelKey: "help.subject",
    placeholder: "Subject",
    placeholderKey: "help.subject",
    lookup: "LK_HELP_SUBJECTS",
    type: FormInputTypes.LOOKUP_SELECT,
    validator: requiredValidator,
  },
  {
    name: "message",
    label: "Message *",
    labelKey: "help.message",
    placeholder: "Message",
    placeholderKey: "help.message",
    type: FormInputTypes.TEXTAREA,
    validator: requiredValidator,
  },
];

export const AskHelp = ({
  buttonClassName,
}: {
  buttonClassName?: string;
}) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  const [lookups, setLookups] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const formRef = useRef(null);

  useEffect(() => {
    loadLookups(formSettings, {}, (data: Array<any>) => {
      setLookups(data);
    });
  }, []);

  const onsubmitHandler = async () => {
    setSubmitting(true);
    if (formRef.current) {
      const values = formRef.current.getFormValues();
      try {
        await submitAskForHelp(values);
        setOpened(false);
        toast.success(t("help.success"));
        setSubmitting(false);
      } catch (e) {
        console.error(e);
        toast.error(t("help.error"));
        setSubmitting(false);
      }
    }
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={t("help.title")}
        closeButtonLabel={t("accessibility.closeHelp")}
        trapFocus
        closeOnEscape
        size="md"
        className="ask-help-modal"
      >
        <div className="modal-content">
          {/* Description */}
          <p className="modal-description">
            {t("help.description")}
          </p>

          {/* Form */}
          <FormComponent
            config={formSettings}
            lookups={lookups}
            ref={formRef}
          />

          {/* Buttons */}
          <div className="modal-buttons">
            <PLButton 
              variant="secondary" 
              size="lg"
              onClick={() => setOpened(false)}
              className="button-flex"
            >
              {t("common.cancel")}
            </PLButton>
            <PLButton 
              variant="blue" 
              size="lg"
              onClick={onsubmitHandler}
              disabled={submitting}
              className="button-flex"
            >
              {submitting ? t("common.sending") : t("common.send")}
            </PLButton>
          </div>
        </div>
      </Modal>

      <PLButton
        variant="green"
        size="lg"
        onClick={() => setOpened(true)}
        ariaLabel={t("help.openAria")}
        className={buttonClassName}
      >
        {t("help.open")}
      </PLButton>
    </>
  );
};
